import { Container } from "theme-ui";
import { SystemStats } from "../components/SystemStats";
import { TradingPair } from "../components/Farm/TradingPair";

export const Utilities: React.FC = () => (
  <Container variant="columns" sx={{ justifyContent: "flex-start" }}>
    <Container variant="left">
      <TradingPair />
    </Container>

    <Container variant="right">
      <SystemStats />
    </Container>
  </Container>
);